module.exports = __webpack_public_path__ + "img/lock.3720ff25.svg";